export const isFollowUpInvoiceSubmission = invoiceSubmissionId => {
    return !invoiceSubmissionId.endsWith('A1');
};
